<template>
  <div>
    <v-hover
      v-if="$vuetify.breakpoint.mdAndUp"
      v-slot:default="{ hover }"
    >
      <v-lazy
        :options="{ threshold: 0.5, }"
        min-height="300"
        transition="fade-transition"
      >
        <transition name="scale" mode="out-in">
          <v-card
            tile
            :elevation="hover ? 3 : 2"
            :class="[
              { 'on-hover': hover },
              { 'v-cardcheck': isCar(item.Codigo) },
              'rounded-lg',
              'mx-auto',
            ]"
            :height="heightCard"
            :max-width="$vuetify.breakpoint.lg ? 250 : 265"
          >
            <v-card
              @click="articuloRoute(item.Codigo)"
              flat
            >
              <v-list
                three-line
                max-height="345px"
              >
                <v-list-item>
                  <v-list-item-content>
                    <div
                      v-if="
                        item.Stock !== 0 &&
                        item.Promocion &&
                        dataUser.IndAutenticado
                      "
                      class="ribbon"
                      transition="slide-x-transition"
                    >
                      ¡EN PROMOCIÓN!
                    </div>
                    <v-avatar
                      tile
                      class="img_art mt-n3"
                      size="170"
                    >
                      <imgPredet
                        :withImg="150"
                        :codart="item.Codigo"
                        :urlimg="imgSrc"
                        :key="updateImg"
                      />
                      <v-fade-transition>
                        <div
                          v-if="hover"
                          class="
                            d-flex
                            transition-fast-in-fast-out
                            warning
                            lighten-4
                            v-card--reveal
                            display-3
                            white--text
                          "
                          style="
                            height: 100%;
                            cursor: pointer;
                            border-radius: 10px;
                          "
                        >
                          <v-icon color="primary" size="40">
                            mdi-plus-circle-outline
                          </v-icon>
                        </div>
                      </v-fade-transition>
                    </v-avatar>
                    <!-- codigo -->
                    <v-row no-gutters>
                      <v-col
                        cols="8"
                        :class="['text-no-wrap text-uppercase font-weight-bold body-2']"
                      >
                        {{ item.Codigo }}
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="4">
                        <span class="d-flex text-right">
                          <div>
                            <v-img
                              :src="`${domoapi2_img}Marca-deco/${item.Marca}/Alto-30?i=${updateImg}&Cia=15`"
                              contain
                              max-width="70"
                            ></v-img>
                          </div>
                        </span>
                      </v-col>
                    </v-row>
                    <!-- nombre -->
                    <v-list-item-subtitle
                      style="max-width: 390px; color: #4d6572"
                      :class="['primary--text text-uppercase font-weight-medium  body-2 ml-0 ma-1']"
                    >
                      {{ item.Nombre }}
                    </v-list-item-subtitle>
                    <!-- disponible-->
                    <v-list-item-title
                      v-if="dataUser.IndAutenticado"
                      :class="['font-weight-medium body-2 ml-0']"
                    >
                      <span v-if="item.DisponTxt === 'Disponible:'">
                        STOCK: {{ item.Stock }}
                        <Paleta v-if="item.UniVenta === `M2`" />
                        <Paquete v-if="item.UniVenta !== `M2`" />
                        <span
                          v-if="dataUser.IndAutenticado"
                          v-html="
                            formatNumber({
                              num: item.Disponible,
                              univenta: item.UniVenta,
                            }) + subValue({ cod: item.UniVenta })
                          "
                        ></span>
                      </span>
                      <span v-else>
                        {{ item.DisponTxt }}
                      </span>
                    </v-list-item-title>
                    <!-- precio y boton grid sel promo-->
                    <v-list-item-title
                      v-if="dataUser.IndAutenticado && dataUser.VerPrecios[tipoMoneda]"
                      :class="['text-truncate text-uppercase font-weight-bold body-2 ml-0']"
                      style="height: 80px"
                    >
                      <span v-if="item.Condicion !== ''">
                        <span>
                          {{ item.Condicion }}
                        </span>
                        <br />
                        <span v-if="item.FchProx !== null">
                          <span :class="['caption']">
                            {{ fechaProx() }}
                          </span>
                          <br />
                        </span>
                      </span>
                      <span v-if="item.Precio[tipoMoneda] !== 0 || dataUser.TipoUsuario === 'U'">
                        <span
                          :class="[
                            'text-uppercase font-weight-medium body-2 ml-0',
                            {
                              'text-uppercase text--secondary':
                              statusPromo(item.Codigo, codArtPromo)
                            },
                          ]"
                        >
                          {{ item.IVA === 0 ? "Exento de IVA" : "No incluye IVA" }}
                        </span>
                        <br />
                        <span
                          :class="[
                            {
                              'text-decoration-line-through text--secondary':
                              statusPromo(item.Codigo, codArtPromo),
                            },
                          ]"
                        >
                          {{ item.TipoPrecio }}
                          {{ simboloMoneda[tipoMoneda] }}
                        </span>
                        <span
                          :class="[
                            {
                              'font-weight-medium text-decoration-line-through text--secondary':
                              statusPromo(item.Codigo, codArtPromo),
                            },
                          ]"
                        >
                          {{ precio({ value: item.Precio[tipoMoneda] }) }}
                        </span>
                        <br />
                        <span
                          v-if="
                            item.Promocion &&
                            statusPromo(item.Codigo, codArtPromo)
                          "
                          :class="['text-truncate text-uppercase font-weight-bold body-2 ml-0']"
                        >
                          <span>
                            {{ item.TipoPrecio }}
                            {{ simboloMoneda[tipoMoneda] }}
                          </span>
                          {{
                            precioPromo(
                              item.Codigo,
                              promoDetalleArt[
                                idpromo(promoDetalleArt) > 1
                                  ? idpromo(promoDetalleArt) - 1
                                  : 0
                              ].codigo
                            ) | numeral("0,0.00")
                          }}
                          <span v-if="dataUser.IndAutenticado">
                            {{
                              precioPromo(
                                item.Codigo,
                                promoDetalleArt[
                                  idpromo(promoDetalleArt) > 1
                                    ? idpromo(promoDetalleArt) - 1
                                    : 0
                                ].codigo
                              )
                                ? "| desc: " +
                                  montoDescuento(
                                    item.Codigo,
                                    promoDetalleArt[
                                      idpromo(promoDetalleArt) > 1
                                        ? idpromo(promoDetalleArt) - 1
                                        : 0
                                    ].codigo
                                  ) +
                                  "%"
                                : ""
                            }}
                          </span>
                          <br />
                        </span>
                      </span>

                      <SelPromo
                        v-if="
                          item.Stock !== 0 &&
                          item.Promocion &&
                          dataUser.IndAutenticado
                        "
                        :infoproducto="item"
                        :codArt="item.Codigo"
                        :isPromo="item.Promocion"
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>

            <v-card-actions v-if="item.Precio[tipoMoneda] !== 0 && item.Stock !== 0">
              <v-row no-gutters>
                <v-col class="text-right">
                  <v-slide-y-transition>
                    <btnAdd
                      :selcliente="Cliente.showOpc"
                      :userAuth="dataUser.IndAutenticado"
                      :codArt="item.Codigo"
                      :promo="item.Promocion"
                      @promoArticulo="newCant"
                      :tipoConsulta="1"
                      :ver="verbtn ? verbtn : hover"
                      :item="item"
                      :textbtn="`agregar`"
                    />
                  </v-slide-y-transition>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </transition>
      </v-lazy>
    </v-hover>
    <!-- Movil -->
    <v-lazy
      v-if="!$vuetify.breakpoint.mdAndUp"
      :options="{ threshold: 0.5, }"
      min-height="180"
      transition="fade-transition"
    >
      <v-card
        :height="alturaCardMovil"
        tile
        :class="[
          'pa-1',
          'mx-auto',
          'elevation-2',
          'rounded-lg',
          { 'v-cardcheck': isCar(item.Codigo) },
        ]"
      >
        <v-row no-gutters>
          <v-col cols="12">
            <div class="d-flex justify-space-between">
              <span class="text-body-1 font-weight-bold ml-1">
                {{ item.Codigo }}
              </span>
              <img
                :src="`${domoapi2_img}Marca-deco/${item.Marca}/Alto-30?i=${updateImg}&Cia=15`"
                :class="['img_art', 'mx-1']"
              />
            </div>
          </v-col>
          <v-col
            cols="3"
            style="cursor: pointer"
            @click="articuloRoute(item.Codigo)"
          >
            <div
              class="ribbon"
              v-if="item.Stock !== 0 && item.Promocion && dataUser.IndAutenticado"
              transition="slide-x-transition"
            >
              ¡EN PROMOCIÓN!
            </div>

            <v-list-item-avatar
              class="mt-4"
              tile size="100"
            >
              <imgPredet
                :codart="item.Codigo"
                :urlimg="imgSrc"
                :key="updateImg"
              />
            </v-list-item-avatar>
          </v-col>
          <v-col cols="9">
            <v-list-item three-line>
              <v-list-item-content>
                <span
                  :class="[ 
                    'font-weight-medium body-2 primary--text',
                    { 'my-5 body-1': !dataUser.IndAutenticado }
                  ]"
                >
                  {{ item.Nombre }}
                </span>
                <v-list-item-title
                  v-if="dataUser.IndAutenticado"
                  :class="['font-weight-medium body-2 ml-0']"
                >
                  <span v-if="item.DisponTxt === 'Disponible:'">
                    STOCK: {{ item.Stock }}
                    <Paleta v-if="item.UniVenta === `M2`" />
                    <Paquete v-if="item.UniVenta !== `M2`" />
                    <span
                      v-if="dataUser.IndAutenticado"
                      v-html="
                        formatNumber({
                          num: item.Disponible,
                          univenta: item.UniVenta,
                        }) + subValue({ cod: item.UniVenta })
                      "
                    ></span>
                  </span>
                  <span v-else>
                    {{ item.DisponTxt }}
                  </span>
                </v-list-item-title>
                <v-list-item-title
                  v-if="dataUser.IndAutenticado && dataUser.VerPrecios[tipoMoneda]"
                  :class="['text-truncate text-uppercase font-weight-bold body-2 ml-0']"
                  style="height: 80px"
                >
                  <span v-if="item.Condicion !== ''">
                    <span>
                      {{ item.Condicion }}
                    </span>
                    <br />
                    <span v-if="item.FchProx !== null">
                      <span :class="['caption']">
                        {{ fechaProx() }}
                      </span>
                      <br />
                    </span>
                  </span>
                  <span v-if="item.Precio[tipoMoneda] !== 0 || dataUser.TipoUsuario === 'U'">
                    <span
                      :class="[
                        'text-uppercase font-weight-medium body-2 ml-0',
                        { 
                          'text-uppercase text--secondary':
                          statusPromo(item.Codigo, codArtPromo)
                        },
                      ]"
                    >
                      {{ item.IVA === 0 ? "Exento de IVA" : "No incluye IVA" }}
                    </span>
                    <br />
                    <span
                      :class="[
                        {
                          'text-decoration-line-through text--secondary':
                            statusPromo(item.Codigo, codArtPromo),
                        },
                      ]"
                    >
                      {{ item.TipoPrecio }}
                      {{ simboloMoneda[tipoMoneda] }}
                    </span>
                    <span
                      :class="[
                        {
                          'font-weight-medium text-decoration-line-through text--secondary':
                            statusPromo(item.Codigo, codArtPromo),
                        },
                      ]"
                    >
                      {{ precio({ value: item.Precio[tipoMoneda] }) }}
                    </span>
                    <br />
                    <span
                      v-if="
                        item.Promocion &&
                        statusPromo(item.Codigo, codArtPromo)
                      "
                      :class="['text-truncate text-uppercase font-weight-bold body-2 ml-0']"
                    >
                      <span>
                        {{ item.TipoPrecio }}
                        {{ simboloMoneda[tipoMoneda] }}
                      </span>
                      {{
                        precioPromo(
                          item.Codigo,
                          promoDetalleArt[
                            idpromo(promoDetalleArt) > 1
                              ? idpromo(promoDetalleArt) - 1
                              : 0
                          ].codigo
                        ) | numeral("0,0.00")
                      }}
                      <span>
                        {{
                          precioPromo(
                            item.Codigo,
                            promoDetalleArt[
                              idpromo(promoDetalleArt) > 1
                                ? idpromo(promoDetalleArt) - 1
                                : 0
                            ].codigo
                          )
                            ? "| desc: " +
                              montoDescuento(
                                item.Codigo,
                                promoDetalleArt[
                                  idpromo(promoDetalleArt) > 1
                                    ? idpromo(promoDetalleArt) - 1
                                    : 0
                                ].codigo
                              ) +
                              "%"
                            : ""
                        }}
                      </span>
                      <br />
                    </span>
                  </span>
                  

                  <SelPromo
                    v-if="
                      item.Stock !== 0 &&
                      item.Promocion &&
                      dataUser.IndAutenticado
                    "
                    :infoproducto="item"
                    :codArt="item.Codigo"
                    :isPromo="item.Promocion"
                  />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-card-actions v-if="item.Precio[tipoMoneda] !== 0 && item.Stock !== 0" class="mt-n12">
          <v-spacer />
          <btnAdd
            :selcliente="Cliente.showOpc"
            :userAuth="dataUser.IndAutenticado"
            :codArt="item.Codigo"
            :promo="item.Promocion"
            @promoArticulo="newCant"
            :tipoConsulta="1"
            :ver="true"
            :item="item"
            :textbtn="`agregar`"
          />
        </v-card-actions>
      </v-card>
    </v-lazy>
  </div>
</template>

<script>
  import btnAdd from "@/components/botonadd";
  import { CarAddBtn } from "../CarAdd/";
  import imgPredet from "@/components/ImgPred";
  import { mapState, mapMutations } from "vuex";
  import SelPromo from "@/components/GridSelPromo";
  import LabelPromo from "./LabelPromo";
  import { formatMiles } from "@/static/funciones";
  import { Paleta, Paquete } from "../Icons";

  export default {
    data() {
      return {
        codXart: false,
        codArtPromo: null,
        promoDetalleArt: [],
        cantMin: 1,
        updateImg: Math.floor(Math.random() * 100),
      };
    },
    computed: {
      ...mapState([
        "dataUser",
        "tipoMoneda",
        "simboloMoneda",
        "PromocionAll",
        "Cliente",
        "Pedido",
        "domoapi2_img",
      ]),
      alturaCardMovil() {
        if (!this.dataUser.IndAutenticado) return 165;
        if (this.dataUser.IndAutenticado && this.Cliente.showOpc) return 180;
        if (this.dataUser.IndAutenticado && !this.Cliente.showOpc) return 215;
      },
      heightCard() {
        if (!this.dataUser.IndAutenticado) return 280;
        if (this.dataUser.IndAutenticado && this.Cliente.showOpc) return 380;
        if (this.dataUser.IndAutenticado && !this.Cliente.showOpc) return 412;
      },
      fechaProx() {
        return () => {
          const fecha = new Date(this.item.FchProx);
          const fchprox = fecha.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit', 
            year: '2-digit'
          });

          return fchprox;
        }
      },
      precio() {
        return ({value}) => {
          const precioFormat = this.formatMiles({
            value: value,
            numDecimal: 2,
          });
          return precioFormat;
        };
      },
      imgSrc() {
        let xSrc = this.domoapi2_img;
        xSrc += "Articulo/";
        xSrc += this.ChrEsp(this.item.Codigo);
        xSrc += "/Principal?";
        xSrc += "Cia=15";
        return xSrc;
      },
      subValue: function () {
        return function ({ cod }) {
          if (cod === "M2") {
            const numero = cod.slice(1); // Extrae el "2"
            const character = cod.slice(0, 1).toLowerCase(); // Extrae el "M"
            return `${character}<sup>${numero}</sup>`; // Formatea como "M<sup>2</sup>"
          } else return cod;
        };
      },
      isCar: function () {
        return function (cod) {
          return this.Pedido.items
            .filter((x) => x["Codigo"] === cod)
            .map((x) => x["Codigo"]).length;
        };
      },
      montoDescuento: function () {
        return function (id, codp) {
          let nb = null;
          if (this.PromocionAll) {
            this.PromocionAll.forEach((item) => {
              if (id === item["articulo"] && item.codigo === codp) {
                nb = item["descuento"];
              }
            });

            return Number.parseFloat(nb);
          }
        };
      },
      statusPromo: function () {
        return function (a, b) {
          return a === b ? this.codXart : false;
        };
      },
      idpromo: function () {
        return function (a) {
          return a ? a.length : 0;
        };
      },
      precioPromo: function () {
        return function (id, codp) {
          if (this.PromocionAll) {
            let nb = this.PromocionAll.filter(
              (x) => x["articulo"] === id && x["codigo"] === codp
            ).map((x) => x["PrecioExt-paq"]);

            return this.dataUser.VerPrecios[this.tipoMoneda] ? nb : 0;
          } else return 0;
        };
      },
    },
    methods: {
      ...mapMutations(["set_disableNav", "CLR_DATOS_ART"]),
      formatMiles,
      ChrEsp(chr) {
        const chrSplit = chr.split("");
        let newChr = "";

        chrSplit.forEach((x) => {
          if (x === "/") newChr += "-";
          else if (x === ".") newChr += "-";
          else newChr += x;
        });

        return newChr;
      },
      formatNumber({ num, univenta }) {
        let numeral = require("numeral");
        const formatNum = univenta !== "M2" ? "0,0" : "0,0.00";
        const result = numeral(num).format(formatNum);
        return result;
      },
      newCant(datos, cant, status, cod) {
        this.promoDetalleArt = datos;
        this.cantMin = cant;
        this.codXart = status;
        this.codArtPromo = cod;
      },
      articuloRoute(codart = encodeURIComponent(codart)) {
        this.set_disableNav(false);
        this.CLR_DATOS_ART();
        this.$router.push({
          path: "/detalle/" + codart,
        });
      },
    },
    components: {
      imgPredet,
      SelPromo,
      btnAdd,
      LabelPromo,
      CarAddBtn,
      Paleta,
      Paquete,
    },
    props: {
      item: Object,
      verbtn: Boolean,
    },
  };
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 0.5;
    position: absolute;
    width: 100%;
  }
  .scale-enter-active,
  .scale-leave-active {
    transition: all 0.5s ease;
  }
  .scale-enter-from,
  .scale-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
  .v-cardcheck {
    background-color: #ffffff !important;
    filter: drop-shadow(0px 1.5px 0 #b05954);
    border-bottom: 5px solid #b05954 !important;
    transition: opacity 0.4s ease-in-out;
    margin: 1px;
  }
  .img_art {
    width: auto;
    height: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .ribbon {
    z-index: 1;
    position: absolute;
    top: -13px;
    left: -5px;
    width: 135px;
    display: block;
    padding: 3px;
    border-radius: 5px;
    background-color: #d3bc8d;
    color: #7c2629;
    text-align: center;
    border-left: 2px solid #b05954 !important;
    border-top: 2px solid #b05954 !important;
  }
  .box {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    font-family: sans-serif;
    text-align: center;
    line-height: 1;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    max-width: 100%;
    max-height: 100%;
    padding: 20px 40px;
  }
  @media (max-width: 960px) {
    .ribbon {
      top: 25px;
      padding: 1px;
      left: -3px;
      width: 120px;
    }
  }
</style>
